import Vue from 'vue';

//

/**
 * @deprecated Use SdsAccordion instead
 */
var script = Vue.component('Accordion', {
    name: 'Accordion',
    props: {
        // used to scroll only after the content is loaded
        contentLoadingData: {
            type: Object,
            default: null,
        },
        openFirstAvailable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            active: null,
            oldActive: null,
        };
    },
    created() {
        this.uuid = 0;
    },
    mounted() {
        if (this.openFirstAvailable) {
            this.setActive({
                index: this.$children.findIndex((child) => !child.$options.propsData.isDisabled),
                height: 0,
            });
        }
    },
    watch: {
        'active.index': function () {
            this.scrollOffset = this.getScrollOffset();
            this.scroll();
        },
        'contentLoadingData.isContentLoaded': function (value) {
            if (value) {
                this.scroll();
            }
        },
    },
    methods: {
        setActive(active) {
            if (!this.active || this.active.index !== active.index) {
                this.oldActive = this.active;
                this.active = active;
                this.$emit('expand', active.index);
            } else {
                this.active = null;
            }
        },
        setActiveHeight(height) {
            this.active.height = height;
        },
        getUuid() {
            const id = this.uuid;
            this.uuid += 1;
            return id;
        },
        getScrollOffset() {
            if (this.active && this.oldActive && this.oldActive.index < this.active.index) {
                return -this.oldActive.height;
            }
            return 0;
        },
        scroll() {
            window.scrollBy(0, this.scrollOffset);
            this.scrollOffset = 0;
        },
    },
});

export default script;
